module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "404"
    }
  }, [_c('div', {
    staticClass: "full-header"
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/",
      "role": "button"
    }
  }, [_vm._v("\n          take me home\n        ")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-xs-offset-3"
  }, [_c('img', {
    staticClass: "center-block img-responsive",
    attrs: {
      "src": require("assets/images/404_image@2x.png"),
      "alt": ""
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-text"
  }, [_c('h1', [_vm._v("Oops, page not found.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-be724476!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PageNotFound.vue
// module id = 591
// module chunks = 2